import { render, staticRenderFns } from "./LoginPass.vue?vue&type=template&id=35b29bfe&scoped=true&"
import script from "./LoginPass.vue?vue&type=script&lang=js&"
export * from "./LoginPass.vue?vue&type=script&lang=js&"
import style0 from "./LoginPass.vue?vue&type=style&index=0&id=35b29bfe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b29bfe",
  null
  
)

export default component.exports